import type { LegDTO, StopDTO } from '@/types/dto/agent';
import { formatTime } from '@/utils/dateTime';
import { Typography } from '@packages/webshop-design-system';
import type { FC } from 'react';

interface LegStopProps {
  stop: StopDTO;
  ptMode?: LegDTO['ptMode'];
  day?: string | null;
  // Raw ISO datetime; wall-clock time is rendered here.
  time?: string | null;
}

const LegStop: FC<LegStopProps> = ({ stop, ptMode, day, time }) => {
  return (
    <div className="flex items-center justify-between tablet:items-start laptop:flex-col">
      <Typography variant="body1-bold" className="text-wrap" as="span">
        {stop.name}
      </Typography>
      {ptMode?.code?.toUpperCase() !== 'WALK' && (
        <div className="flex gap-2">
          {day && (
            <Typography variant="body1" className="text-neutral">
              {day}
            </Typography>
          )}
          {time && <Typography variant="body1">{formatTime(time)}</Typography>}
        </div>
      )}
    </div>
  );
};

export default LegStop;
